<div class="panel">
  <h1>Страница не найдена</h1>
  <a [routerLink]="['/']" class="btn">Перейти на главную</a>
</div>
